<template>
      <b-form-group
            :id="`input${id}`" class="input-confirm-password"
          >
            <b-input-group class="mb-2">
              <b-form-input
                :id="id"
                :value="value"
                :type="type"
                :placeholder="placeholder"
                :state="state"
                @input="setPassword"
                required
              ></b-form-input>

              <b-input-group-append>
                <b-button @mousedown=" passwordShow" @mouseup="passwordHide">
                  <b-icon-eye-slash-fill class="b-icon-eye-slash-fill"/>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
</template>

<script>
export default {
      name : "InputConfirmPassword",
      data(){
        return {
          type : "password"
        }
      },
      props : {
            placeholder : String,
            value: String,
            validationMessage: String,
            id: String
      },
      methods:{
            //Ativa e desativa o visualizador de senha
            passwordShow() { this.type = "text" },
            passwordHide() { this.type = "password" },
            setPassword(value) { this.$emit('input', value) }
      },
      computed: {
            state() {
                  if (this.validationMessage == null)
                        return null

                  return !this.validationMessage
            }
      }
}
</script>

<style scoped>
.b-icon-eye-slash {
  transition: 0.1s;
}

.b-icon-eye-slash:hover {
  height: 1.1em;
  width: 1.1em;
}

div div button{
  position: relative !important;
  height: 31px !important;  
  width: 40px !important;
  left: -2px;
  display: flex;
  align-items: center;
  background-color: #fff;
  color: #888b8d;
  border: none;
}

div div button:hover , div div button:active, div div button:focus{
  color: #888b8d !important;
  background-color: #fff !important;
  box-shadow: none !important;
}

html body .input-confirm-password .input-group{
  border: 1px solid #bbbec0;
  border-radius: 4px;
}

html body .input-confirm-password .input-group .form-control{
  border: none !important;
}

</style>